module.exports = __webpack_public_path__ + "img/certificate.517ed1a9.png";